<template lang="pug">
.v-collection-card.collection-card(v-if="data")
	a.collection-card__link(v-if="activeProduct && activeProduct.link && activeProduct.link.href" :href="activeProduct.link.href")
	.collection-card__visual
		.collection-card__top-tags(v-if="data.topTags && data.topTags.length")
			.collection-card__top-tag(v-for="tag of data.topTags") {{tag}}
		.collection-card__tags(v-if="data.tags && data.tags.length")
			.collection-tags
				.collection-tag__list
					template(v-for="(tag, index) in data.tags" :key="index" )
						.collection-tag__item
							.collection-tag
								.collection-tag__bg
								.collection-tag__text(v-if="tag.text") {{ tag.text }}
		img.collection-card__img(v-if="activeProduct && activeProduct.image && activeProduct.image.src" :src="activeProduct.image.src")

	.collection-card__body
		.collection-card__left
			button.btn-simple(type="button" v-if="data.name" )
				| {{data.name}}
				.btn-simple__icon.icon-next
					span
		.collection-card__right(v-if="data.count")
			button.collection-btn(v-if="data.items && data.items.length" @click="showAsideModal")
				.collection-btn__icon
					v-svg-icon.list-icon(icon="list")
				.collection-btn__value(v-if="data.count.value") {{data.count.value}}
				.collection-btn__text(v-if="data.count.text") {{data.count.text}}
	.collection-card__colors(v-if="data && data.collections && data.collections.length > 1")
		template(v-for="(item, index) in data.collections" :key="index" )
			.collection-card__color
				button.offer-item(:class="{'offer-item--active' : item.id === activeProduct.id}" @click="setActiveProduct(item)")
					.offers-item__img(v-if="item.preview && item.preview" :style="{backgroundColor: item.preview}")
	.collection-card__desc(v-if="data.desc") {{data.desc}}
</template>

<script>
	import sourceMixin from '../components/mixins/v-mixin-source.vue';
	import scrollLock from 'scroll-lock';
	import { mapMutations } from 'vuex';

	export default {

		mixins: [
			sourceMixin
		],

		data() {
			return {
				data: null,
				activeProduct: null
			}
		},

		methods: {
			dataSet(data) {
				this.data = data;
				if(this.data.collections && this.data.collections.length) {
					const [first] = this.data.collections;
					this.activeProduct = first;
				}
			},
			setActiveProduct(item) {
				this.activeProduct = item;
			},
			...mapMutations({
				set: 'previewCollection/set',
				clear: 'previewCollection/clear'
			}),
			showAsideModal() {
				const { items = null, name = null } = this.data;
				if(items && items.length) {
					this.set({
						items,
						name
					});

					this.$nextTick(() => {
						scrollLock.enablePageScroll();
						scrollLock.disablePageScroll(document.querySelectorAll('.filter-aside__inner'));
					})

				}
			}
		}
	}

</script>